import { Paragraph20 } from '@squareup/dex-ui-shared-base';
import { MarketRow } from '@squareup/dex-ui-shared-market';
import React, {
  FC,
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
  useCallback,
} from 'react';

import { useHighlightedComboboxLabel } from './combobox-hooks';

interface Props {
  value: string;
  displayText?: string | undefined;
  description?: ReactNode | undefined;
  highlightText?: string | undefined;
  onArrowUp?: (() => Promise<void> | void) | undefined;
  onArrowDown?: (() => Promise<void> | void) | undefined;
  onClick?: MouseEventHandler<globalThis.HTMLMarketRowElement> | undefined;
}

const ComboboxPopoverRow: FC<Props> = ({
  value,
  displayText,
  description,
  highlightText,
  onArrowUp,
  onArrowDown,
  onClick,
}) => {
  const displayLabel = useHighlightedComboboxLabel(
    displayText || value,
    highlightText
  );

  const onKeyDown = useCallback<
    KeyboardEventHandler<globalThis.HTMLMarketRowElement>
  >(
    (e) => {
      if (e.key === 'ArrowUp' && onArrowUp) {
        e.preventDefault();
        onArrowUp();
      } else if (e.key === 'ArrowDown' && onArrowDown) {
        e.preventDefault();
        onArrowDown();
      }
    },
    [onArrowUp, onArrowDown]
  );

  return (
    <MarketRow
      value={value}
      size="small"
      onKeyDown={onKeyDown}
      onClick={onClick}
      selected={value === highlightText}
    >
      <Paragraph20 weight="medium" as="label" slot="label">
        {displayLabel || value}
      </Paragraph20>
      {description && (
        <Paragraph20 as="span" slot="subtext" colorVariant="20">
          {description}
        </Paragraph20>
      )}
    </MarketRow>
  );
};

export { ComboboxPopoverRow };
